export class MultipleFilterProperty {
  dispalyName: string = '';
  value: string = '';
  dateValue: string = '';
  column: string = '';
  dateBackendName: string = '';
  origionalStartDateFormat!: Date;
  origionalEndDateFormat!: Date;
}